<template>
    <div class="calendar">
        <calendar-period />
        <calendar-button
            v-on:open-menu-request="openMenu = $event"
            v-bind:openMenu="this.openMenu"
            v-bind:toggle-menu="toggleMenu"
        />
        <calendar-menu
            v-on:open-menu-request="openMenu = $event"
            v-bind:openMenu="this.openMenu"
            v-bind:toggle-menu="toggleMenu"
        />
        <div
            class="calendar-overlay"
            v-if="this.openMenu"
            v-on:click="toggleMenu"
        ></div>
    </div>
</template>

<script>
import CalendarPeriod from '~/components/address/Calendar/CalendarPeriod.vue';
import CalendarButton from './CalendarButton.vue';
import CalendarMenu from './CalendarMenu.vue';

export default {
    data() {
        return {
            openMenu: false,
            scrollPosition: 0,
        };
    },
    methods: {
        toggleMenu() {
            this.openMenu = !this.openMenu;
            this.$store.commit('updateFilterVisible', !this.openMenu);
            if (this.isMobile) {
                if (this.openMenu === true) {
                    this.scrollPosition = window.scrollY;
                    document.body.classList.add('no-scroll-body');
                    document.body.style.top = `-${this.scrollPosition}px`;
                } else {
                    document.body.classList.remove('no-scroll-body');
                    document.body.style.top = '';
                    window.scrollTo(0, this.scrollPosition);
                }
            }
        },
    },
    components: {
        CalendarPeriod,
        CalendarButton,
        CalendarMenu,
    },
};
</script>

<style lang="scss">
.calendar {
    padding: 0 0 0 10px;
    position: relative;
    display: flex;
    gap: 12px;
    align-items: center;
}
.calendar-button {
    cursor: pointer;
    position: relative;
}
.calendar-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 90000;
}
.no-scroll-body {
    position: fixed;
    width: 100%;
    overflow: hidden;
}
@media screen and (max-width: 599px) {
    .calendar-overlay {
        background: rgba(0,0,0,0.4);
    }
}
</style>
